import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { SettlementItem } from '~/models/SettlementItem';

const paths = {
  index: '/settlement_items'
};
type TIndex = () => SwrReturnType<SettlementItem[]>;
type ReturnType = {
  index: TIndex;
};

export const useSettlementItems = (): ReturnType => {
  const index: TIndex = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSWR<SettlementItem[]>(paths.index);
    return {
      data: data ?? [],
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
